import React, { useState, useEffect } from 'react';
import { Grid, Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import reportslogo from "../../assets/images/reportslogo.png";
import Axios from 'axios';
import { getAuthToken, getFacilityId, getcompanyId } from "../../utility/tokenUtility";
import { ifacSecurityURL } from "../../utility/apiURLS";
import moment from 'moment';
const Tcviewfile = ({ data, rowData }) => {
    const [state, setState] = useState('');
    const stateid = data[0]?.stateid;

    console.log(data[0]?.signatures);

    const handleState = async () => {  // Add async to the function
        try {
            const token = getAuthToken("id_token");  // Assuming you have a token function
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,  // Authorization header
                },
            };


            const response = await Axios.get(`${ifacSecurityURL}/api/secstatemasters/${stateid}`, config);

            const stateName = response.data?.statename || response.data?.state?.name || "Unknown";
            setState(response.data?.statename);



        } catch (error) {
            console.error("Error fetching state data:", error);
        }
    };

    useEffect(() => {
        if (stateid) {
            handleState();
        }
    }, [stateid]);
    console.log(data, "data");

    const facilityAcknowledgedRoles = ["Engineer", "Technician", "FEMS Staff", "FMS H.O.D", "Nominated Person", "Others"];
    
    // Ensure data[0]?.signatures exists
    const signatureData = data[0]?.signatures || [];
    
    // Find specific signatures
    const userAcceptance = signatureData.find((sig) => sig.signDesc === "End-User");
    const vendorDelivered = signatureData.find((sig) => sig.signDesc === "Vendor");
    const facilityAcknowledged = signatureData.find((sig) => facilityAcknowledgedRoles.includes(sig.signDesc));
    
    
    
    return (
        <Box
            sx={{
                padding: '5mm',
                width: '210mm',
                height: '297mm',
                backgroundColor: '#fff',
                border: 'none',
                margin: 0,
                boxSizing: 'border-box',
            }}
        >



            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <img src={reportslogo} alt="logo" style={{ maxWidth: '100px', height: '95px' }} />
                </Grid>
                <br></br>
                <br></br>
                <Grid item xs={6} style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '20px' }}>
                <Typography sx={{ fontSize: '14px' }}>
    <strong style={{ textTransform: 'capitalize' }}>
        {data[0]?.vendorName}
    </strong>
    <br />

    {data[0]?.vendorAddress && (
        <span style={{ textTransform: 'capitalize' }}>
            {data[0].vendorAddress}
            <br />
        </span>
    )}

    {data[0]?.vendorTelePhone && (
        <>
            Tel: {data[0].vendorTelePhone}
        </>
    )}

    {data[0]?.vendorTelePhone && data[0]?.vendorFaxNo && '  '}

    {data[0]?.vendorFaxNo && (
        <>
            Fax: {data[0].vendorFaxNo}
        </>
    )}
</Typography>

                </Grid>
            </Grid>
            <br></br>
            <Box my={2}>
                <Typography
                    variant="h6"
                    align="center"
                    gutterBottom
                    sx={{ fontSize: '28px', fontWeight: 'bold', fontFamily: "Arial Narrow" }} >

                    COMMISSIONING CERTIFICATE
                </Typography>
            </Box>
            <br></br>

            <Box my={3}>
                <Typography variant="body2" gutterBottom sx={{ fontSize: '16px' }}>
                    This is to Certify that the Equipment/system/instrument Specified below has been delivered, installed and commissioned accordingly.
                </Typography>
            </Box>

            {/* Installation and Commissioning Dates */}
            <Table
                sx={{
                    width: '80%', // Adjust width as needed
                    margin: 'auto', // This centers the table horizontally
                    padding: '10px',
                    border: 'none',
                    borderCollapse: 'collapse',
                }}
            >
                {/* Installation and Commissioning Dates */}
                <TableRow sx={{ border: 'none' }}>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography sx={{ fontSize: '14px' }}>
                            <strong>Installation Date:</strong>
                        </Typography>
                    </TableCell>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography sx={{ fontSize: '14px' }}>
                            {data[0]?.installationDate ? moment(data[0].installationDate).format('DD/MM/YYYY') : ''}
                        </Typography>
                    </TableCell>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography sx={{ fontSize: '14px' }}>
                            <strong>Commissioning Date:</strong>
                        </Typography>
                    </TableCell>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography sx={{ fontSize: '14px' }}>
                            {data[0]?.commissionDate ? moment(data[0].commissionDate).format('DD/MM/YYYY') : ''}
                        </Typography>
                    </TableCell>
                </TableRow>

                {/* Equipment / Device and Model / Serial Number */}
                <TableRow sx={{ border: 'none' }}>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                            <strong>Equipment / Device:</strong>
                        </Typography>
                    </TableCell>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                            {data[0]?.equipment||''}
                        </Typography>
                    </TableCell>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                            <strong>Model / Serial Number:</strong>
                        </Typography>
                    </TableCell>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                        {(data[0]?.model || '') + ' / ' + (data[0]?.serialNo || '')}

                        </Typography>
                    </TableCell>
                </TableRow>

                {/* Manufacturer and Warranty Period */}
                <TableRow sx={{ border: 'none' }}>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                            <strong>Manufacturer:</strong>
                        </Typography>
                    </TableCell>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                            {data[0]?.manufacture||''}
                        </Typography>
                    </TableCell>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                            <strong>Warranty Period:</strong>
                        </Typography>
                    </TableCell>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                            {data[0]?.warrentyperiod||''}
                        </Typography>
                    </TableCell>
                </TableRow>

                {/* Warranty Start and End Date */}
                <TableRow sx={{ border: 'none' }}>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                            <strong>Warranty Start Date:</strong>
                        </Typography>
                    </TableCell>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                            {data[0]?.warrentystartdate ? moment(data[0].warrentystartdate).format('DD/MM/YYYY') : ''}
                        </Typography>
                    </TableCell>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                            <strong>Warranty End Date:</strong>
                        </Typography>
                    </TableCell>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                            {data[0]?.warrentyenddate ? moment(data[0].warrentyenddate).format('DD/MM/YYYY') : ''}
                        </Typography>
                    </TableCell>
                </TableRow>

                {/* PPM Service, P/O No */}
                <TableRow sx={{ border: 'none' }}>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                            <strong>Asset Lifespan:</strong>
                        </Typography>
                    </TableCell>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                            {data[0]?.lifespan || ''}
                        </Typography>
                    </TableCell>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                            <strong>P/O No:</strong>
                        </Typography>
                    </TableCell>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                            {data[0]?.poNumber}
                        </Typography>
                    </TableCell>
                </TableRow>

                {/* Purchase Cost */}
                <TableRow sx={{ border: 'none' }}>
                    <TableCell sx={{ border: 'none' }}>
                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                            <strong>Purchase Cost:</strong>
                        </Typography>
                    </TableCell>
                    <TableCell colSpan={3} sx={{ border: 'none' }}>
                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                            {data[0]?.purchasecost || ''}
                        </Typography>
                    </TableCell>
                </TableRow>
            </Table>


            <br></br>
            <br></br>
            {/* <Typography variant="body2" gutterBottom sx={{ fontSize: '14px' }}>
                <strong style={{ display: 'inline-block', marginRight: '4px' }}>**Note:</strong>Warranty mentioned above inclusive 2 PPM/year, Unlimited Breakdown Calls, With Parts (EXCLUDE of Consumables / Accessories)
                <strong style={{ display: 'inline-block', marginRight: '4px' }}></strong>
            </Typography> */}


            <br></br>
            <br></br>
            <Box sx={{ padding: '15px' }}>
            <Grid container spacing={2} justifyContent="space-between" alignItems="center">
        {/* User Acceptance */}
     
            <Grid item xs={4}>
                <h4>User Acceptance</h4>
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                    <strong>Name:</strong> {userAcceptance?userAcceptance.signName:''}
                </Typography>
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                    <strong>Designation:</strong> {userAcceptance?userAcceptance.signDesc:''}
                </Typography>
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                    <strong>Date:</strong> {userAcceptance?moment(userAcceptance.signDate).format("DD/MM/YYYY"):''}
                </Typography>
            </Grid>
   

       
        {/* Facility Acknowledged (Only one entry, even if multiple exist) */}
    
            <Grid item xs={4}>
                <h4>Facility Acknowledged</h4>
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                    <strong>Name:</strong> {facilityAcknowledged?facilityAcknowledged.signName:''}
                </Typography>
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                    <strong>Designation:</strong> {facilityAcknowledged?facilityAcknowledged.signDesc:''}
                </Typography>
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                    <strong>Date:</strong> {facilityAcknowledged?moment(facilityAcknowledged.signDate).format("DD/MM/YYYY"):''}
                </Typography>
            </Grid>
    
         {/* Vendor Delivered */}
         <Grid item xs={4}>
        <h4>Vendor Delivered</h4>
        <Typography variant="body2" sx={{ fontSize: "14px" }}>
          <strong>Name:</strong> {vendorDelivered ? vendorDelivered.signName : ''}
        </Typography>
        <Typography variant="body2" sx={{ fontSize: "14px" }}>
          <strong>Designation:</strong> {vendorDelivered ? vendorDelivered.signDesc : ''}
        </Typography>
        <Typography variant="body2" sx={{ fontSize: "14px" }}>
          <strong>Date:</strong> {vendorDelivered ? moment(vendorDelivered.signDate).format("DD/MM/YYYY") : ''}
        </Typography>
      </Grid>

    </Grid>

</Box>




        </Box>
    );
};

export default Tcviewfile